import React, { useCallback, useEffect, useState, useRef } from "react";
import {
  Form,
  Row,
  Col,
  InputGroup,
  Card,
  Button,
  Table,
} from "react-bootstrap";
import {
  IconCopyMinus,
  IconGridDots,
  IconInvoice,
  IconSearch,
  IconCoin,
  IconPercentage,
  IconCurrencyDollar,
  IconArrowNarrowRight,
  IconPlus,
  IconTrash,
  IconLock,
  IconLockOpen2,
  IconArrowsUpDown,
} from "@tabler/icons-react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { useSelector } from "react-redux";
import { useFormContext, useFieldArray } from "react-hook-form";
import {
  API_ENDPOINTS,
  handleKeyDown,
  roundToMoney,
  trimText,
  truncateFormat,
} from "../../constant/_constant";
import SkuSearchPopUp from "./SkuSearchPopUp";

import useDebounce from "../../hooks/useDebounce";
import usePostRequest from "../../hooks/usePostRequest";
import { toast } from "react-toastify";
import { trimTrailingZeros } from "../../utils/_helpers";
import FbopPdfPopup from "./FbopPdfPopup";
import PdfProductsPopup from "./PdfProductsPopup";

function OtherDetailsForm({ isEditing }) {
  const {
    getValues,
    register,
    watch,
    control,
    formState: { errors },
    setValue,
  } = useFormContext();
  const contractName = useSelector((state) => state.contract.contractName);

  const textareaRef = useRef(null);

  const [dataSuggetion, setDataSuggetion] = useState([]);
  const [marginWarnings, setMarginWarnings] = useState({});
  const [vendorWarnings, setVendorWarnings] = useState({}); // New state for vendor warnings
  const [suggestionData, setSuggestionData] = useState([]);
  const [height, setHeight] = useState();
  const [shippingHide, setShippingHide] = useState(false);
  const [totalCostBeforeMargin, setTotalCostBeforeMargin] = useState("0.00");
  const [totalCostAfterMargin, setTotalCostAfterMargin] = useState("0.00");
  const [showModal, setShowModal] = useState(false);
  const [searchType, setSearchType] = useState("");
  const [showSkuId, setShowSkuId] = useState(false);
  const [showFbopPopup, setShowFbopPopup] = useState(false);
  // Add this state to track original vendors from product selection
  // const [originalVendors, setOriginalVendors] = useState({});
  const [searchProps, setSearchProps] = useState({
    searchSku: "",
    searchDescription: "",
    searchVendor: "",
    indexIs: "",
    ContractName: "",
  });
  const [showPdfProductsPopup, setShowPdfProductsPopup] = useState(false);
  const [selectedAutoId, setSelectedAutoId] = useState(null);

  useEffect(() => {
    const currentOriginalVendors = getValues("originalVendors") || {};
    if (!getValues("originalVendors")) {
      setValue("originalVendors", {});
    }
  }, [getValues, setValue]);

  const [searchDebounces, setSearchDebounces] = useState({
    searchName: "",
  });

  const { data: vendors, postData: fetchVendors } = usePostRequest(
    API_ENDPOINTS.GET_VENDORS,
  );

  // console.log("originalVendors", originalVendors);

  useEffect(() => {
    if (searchDebounces?.searchName?.length > 0) {
      fetchVendors(
        {
          search:
            searchDebounces?.searchName?.length > 0
              ? searchDebounces?.searchName
              : undefined,
        },
        onSuggestionSuccessData,
      );
    }
  }, [searchDebounces]);

  const onSuggestionSuccessData = (data) => {
    setSuggestionData(data);
  };

  const handleSearchByName = (e) => {
    setSearchDebounces({ searchName: e.target.value });
  };

  // const handleSelectVendor = (item, index) => {
  //   // The function that will set the vendor's display name only for a card
  //   setValue(`cards[${index}].vendorPartner`, item?.display_name, {
  //     shouldValidate: true,
  //   });
  //   setSuggestionData([]);
  //   setSearchDebounces({ searchName: "" });
  // };

  const handleSelectVendor = (item, index) => {
    const currentVendorPartner = getValues(`cards[${index}].vendorPartner`);
    const originalVendors = getValues("originalVendors") || {};
    const originalVendor = originalVendors[index];
    const newVendor = item?.display_name;

    // Check if this is a change from the original product vendor
    if (originalVendor && originalVendor !== newVendor) {
      setVendorWarnings((prevWarnings) => ({
        ...prevWarnings,
        [index]: true,
      }));
      // console.log(`Vendor changed for card ${index}:`, {
      //   original: originalVendor,
      //   new: newVendor,
      //   productSku: getValues(`cards[${index}].skuId`),
      // });
    } else {
      setVendorWarnings((prevWarnings) => {
        const updated = { ...prevWarnings };
        delete updated[index];
        return updated;
      });
    }

    setValue(`cards[${index}].vendorPartner`, newVendor, {
      shouldValidate: true,
    });

    // Clear suggestions
    setSuggestionData([]);
    setSearchDebounces({ searchName: "" });
  };

  const handleMarginChange = (index, marginValue) => {
    setValue(`cards[${index}].margin`, marginValue);
    setMarginWarnings((prevWarnings) => ({
      ...prevWarnings,
      [index]: parseFloat(marginValue) < 8,
    }));
  };

  const handleOpenModal = (index, type) => {
    if (index === null && type === "skuAll") {
      setSearchType(type);
      const currentCards = getValues("cards");
      const blankIndex = currentCards.findIndex(
        (card) => !card.skuId && !card.cost && !card.skuDescription,
      );

      if (blankIndex !== -1) {
        setSearchProps({
          searchSku: "",
          searchDescription: "",
          searchVendor: "",
          indexIs: blankIndex,
        });
      } else {
        setSearchProps({
          searchSku: "",
          searchDescription: "",
          searchVendor: "",
          indexIs: undefined,
        });
      }
    } else if (index === null && type === "contract") {
      setSearchType(type);
      // console.log("popup opened for ", searchType);
      const currentCards = getValues("cards");
      const blankIndex = currentCards.findIndex(
        (card) => !card.skuId && !card.cost && !card.skuDescription,
      );
      if (blankIndex !== -1) {
        setSearchProps({
          searchSku: "",
          searchDescription: "",
          searchVendor: "",
          ContractName: contractName,
          indexIs: blankIndex,
        });
      } else {
        setSearchProps({
          searchSku: "",
          searchDescription: "",
          searchVendor: "",
          ContractName: contractName,
          indexIs: undefined,
        });
      }
    } else {
      const { vendor, sku, description } = cardSearch[index];
      setSearchType(type);
      setSearchProps({
        searchSku: sku,
        searchDescription: description,
        searchVendor: vendor,
        indexIs: index,
      });
    }
    setShowModal(true);
  };

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const {
    fields: cardFields,
    append: appendCard,
    remove: removeCard,
  } = useFieldArray({
    control,
    name: "cards",
  });

  const {
    fields: otherCostFields,
    append: appendOtherCost,
    remove: removeOtherCost,
  } = useFieldArray({
    control,
    name: "otherCost",
  });

  const handleAddOtherCost = () => {
    appendOtherCost({
      Name: "",
      Amount: "",
    });
  };

  const contractVehicletype = watch("contractVehicletype");

  // function generateUniqueId10() {
  //   const array = new Uint8Array(8);
  //   crypto.getRandomValues(array);

  //   return btoa(String.fromCharCode(...array))
  //     .replace(/[^a-zA-Z0-9]/g, "")
  //     .slice(0, 10);
  // }

  const generateUniqueId10 = () => {
    const array = new Uint8Array(8);
    crypto.getRandomValues(array);

    const id = btoa(String.fromCharCode(...array))
      .replace(/[^a-zA-Z0-9]/g, "")
      .slice(0, 10);

    // console.log("Generated ID:", id);
    return id;
  };

  const handleAddCard = () => {
    const newIndex = cardFields.length;
    const rowId = generateUniqueId10();
    appendCard({
      vendorPartner: "",
      skuId: "",
      skuDescription: "",
      productName: "",
      rowId: rowId,
      purchase_description: "",
      internalSku: "",
      variantId: "",
      qty: 1,
      um: "EA",
      cost: "",
      margin: 0,
      customerCost: "",
      totalSkuCost: "",
      clin: "",
    });

    setVendorWarnings((prev) => {
      const updated = { ...prev };
      delete updated[newIndex];
      return updated;
    });
    const currentOriginalVendors = getValues("originalVendors") || {};
    setValue("originalVendors", {
      ...currentOriginalVendors,
      [newIndex]: undefined, // Initialize with undefined for new card
    });
    // calculateCosts();
  };

  // console.log("ORIGINAL VENDORS KI LIST", getValues("originalVendors"));

  const handleAddSku = (product) => {
    const currentValues = getValues("cards") || [];
    const newIndex = currentValues.length;

    // Set the original vendor for the new card
    const currentOriginalVendors = getValues("originalVendors") || {};
    setValue("originalVendors", {
      ...currentOriginalVendors,
      [newIndex]: product?.Vendor?.display_name,
    });

    // Clear any vendor warning for the new card
    setVendorWarnings((prev) => {
      const updated = { ...prev };
      delete updated[newIndex];
      return updated;
    });

    const isProductBound = contractVehicletype
      ?.split(",")
      .includes("product-bound");

    const rowId = generateUniqueId10();

    const effectiveRowId = isProductBound ? product?.raw_sku_id : rowId;

    if (product?.customer_price === "0.00") {
      appendCard({
        vendorPartner: product?.Vendor?.display_name,
        skuId: product?.sku_display_name,
        skuIdUnique: product?.sku_id,
        skuDescription: product?.description_sales,
        purchase_description: product?.description,
        internalSku: product?.internal_id || product?.vendor_sku || "",
        variantId: product?.variant_id || product?.Product?.variant_id || "",
        productName: product?.name,
        qty: 1,
        um: "EA",
        rowId: effectiveRowId,
        cost: trimTrailingZeros(product?.aspetto_price),
        margin: 8,
        clin: product?.clin_id,
        // customerCost: (product?.aspetto_price / (1 - 8 / 100)).toFixed(2),
        // customerCost: truncateFormat(product?.aspetto_price / (1 - 8 / 100), 2),
        customerCost: roundToMoney(product?.aspetto_price / (1 - 8 / 100)),
        // totalSkuCost: truncateFormat(product?.aspetto_price / (1 - 8 / 100), 2),
        totalSkuCost: roundToMoney(product?.aspetto_price / (1 - 8 / 100)),
        // totalSkuCost: (product?.aspetto_price / (1 - 8 / 100)).toFixed(2),
      });
    } else {
      const margin =
        ((product?.customer_price - product?.aspetto_price) /
          product?.customer_price) *
        100;
      appendCard({
        vendorPartner: product?.Vendor?.display_name,
        skuId: product?.sku_display_name,
        skuIdUnique: product?.sku_id,
        skuDescription: product?.description_sales,
        purchase_description: product?.description,
        productName: product?.name,
        internalSku: product?.internal_id || product?.vendor_sku || "",
        variantId: product?.variant_id || product?.Product?.variant_id || "",
        qty: 1,
        clin: product?.clin_id,
        um: "EA",
        rowId: effectiveRowId,
        cost: trimTrailingZeros(product?.aspetto_price),
        // margin: parseFloat(margin.toFixed(2)),
        margin: truncateFormat(margin, 4),
        customerCost: product?.customer_price,
        totalSkuCost: product?.customer_price,
      });
    }
    calculateCosts();
    toast.success(`Product ${product.sku_display_name} is added successfully`);
  };

  const handleAddSkuBulk = (products) => {
    const currentValues = getValues("cards") || [];
    const currentOriginalVendors = getValues("originalVendors") || {};

    products.forEach((product, i) => {
      const newIndex = currentValues.length + i;
      const rowId = generateUniqueId10();

      currentOriginalVendors[newIndex] = product?.Vendor?.display_name;

      setVendorWarnings((prev) => {
        const updated = { ...prev };
        delete updated[newIndex];
        return updated;
      });

      if (product?.customer_price === "0.00") {
        appendCard({
          vendorPartner: product?.Vendor?.display_name,
          skuId: product?.sku_display_name,
          skuIdUnique: product?.sku_id,
          skuDescription: product?.description_sales,
          purchase_description: product?.description,
          productName: product?.name,
          internalSku: product?.internal_id || product?.vendor_sku || "",
          variantId: product?.variant_id || "",
          qty: product?.quantity || 1,
          um: product?.uoi || "EA",
          rowId,
          cost: trimTrailingZeros(product?.aspetto_price),
          margin: 8,
          clin: "",
          customerCost: roundToMoney(product?.aspetto_price / (1 - 8 / 100)),
          totalSkuCost: roundToMoney(product?.aspetto_price / (1 - 8 / 100)),
        });
      } else {
        const margin =
          ((Number(product?.customer_price) - Number(product?.aspetto_price)) /
            Number(product?.customer_price)) *
          100;
        appendCard({
          vendorPartner: product?.Vendor?.display_name,
          skuId: product?.sku_display_name,
          skuIdUnique: product?.sku_id,
          skuDescription: product?.description_sales,
          purchase_description: product?.description,
          productName: product?.name,
          qty: product?.quantity || 1,
          internalSku: product?.internal_id || product?.vendor_sku || "",
          variantId: product?.variant_id || "",
          um: product?.uoi || "EA",
          rowId,
          cost: trimTrailingZeros(product?.aspetto_price),
          margin: truncateFormat(margin, 4),
          clin: "",
          customerCost: product?.customer_price,
          totalSkuCost: product?.customer_price,
        });
      }
    });

    setValue("originalVendors", currentOriginalVendors);
    calculateCosts();
    toast.success(`${products.length} product(s) added successfully`);
  };

  const handleLockUnLock = (e, index, type) => {
    e.stopPropagation();
  };

  useEffect(() => {
    const existingCards = getValues("cards");
    const rowId = generateUniqueId10();
    if (!existingCards || existingCards.length === 0) {
      appendCard({
        vendorPartner: "",
        skuId: "",
        skuDescription: "",
        purchase_description: "",
        productName: "",
        rowId: rowId,
        internalSku: "",
        variantId: "",
        qty: 1,
        um: "EA",
        cost: "",
        margin: 0,
        customerCost: "",
        totalSkuCost: "",
        clin: "",
      });
    }
  }, [appendCard, getValues]);

  const handleRemoveCard = (index) => {
    if (cardFields.length > 1) {
      // Remove warnings for the deleted card
      setMarginWarnings((prev) => {
        const updated = { ...prev };
        delete updated[index];
        // Reindex warnings to match new card indices
        const reindexed = {};
        Object.keys(updated).forEach((key) => {
          const oldIndex = parseInt(key);
          if (oldIndex > index) {
            reindexed[oldIndex - 1] = updated[oldIndex];
          } else if (oldIndex < index) {
            reindexed[oldIndex] = updated[oldIndex];
          }
        });
        return reindexed;
      });

      setVendorWarnings((prev) => {
        const updated = { ...prev };
        delete updated[index];
        // Reindex warnings to match new card indices
        const reindexed = {};
        Object.keys(updated).forEach((key) => {
          const oldIndex = parseInt(key);
          if (oldIndex > index) {
            reindexed[oldIndex - 1] = updated[oldIndex];
          } else if (oldIndex < index) {
            reindexed[oldIndex] = updated[oldIndex];
          }
        });
        return reindexed;
      });

      // Remove and reindex originalVendors
      const currentOriginalVendors = getValues("originalVendors") || {};
      const updatedOriginalVendors = {};
      Object.keys(currentOriginalVendors).forEach((key) => {
        const oldIndex = parseInt(key);
        if (oldIndex !== index) {
          const newIndex = oldIndex > index ? oldIndex - 1 : oldIndex;
          updatedOriginalVendors[newIndex] = currentOriginalVendors[oldIndex];
        }
      });
      setValue("originalVendors", updatedOriginalVendors);

      removeCard(index);
      setTimeout(() => {
        const updatedCards = getValues("cards");
        calculateCosts(updatedCards);
      }, 0);
    }
  };

  // const handleRemoveCard = (index) => {
  //   if (cardFields.length > 1) {
  //     // Clear both warnings and original vendor for this card
  //     setMarginWarnings((prev) => {
  //       const updated = { ...prev };
  //       delete updated[index];
  //       return updated;
  //     });

  //     setVendorWarnings((prev) => {
  //       const updated = { ...prev };
  //       delete updated[index];
  //       return updated;
  //     });

  //     const currentOriginalVendors = getValues("originalVendors") || {};
  //     const updatedOriginalVendors = { ...currentOriginalVendors };
  //     delete updatedOriginalVendors[index];
  //     setValue("originalVendors", updatedOriginalVendors);
  //     // setOriginalVendors((prev) => {
  //     //   const newVendors = { ...prev };
  //     //   delete newVendors[index];
  //     //   return newVendors;
  //     // });

  //     removeCard(index);
  //     setTimeout(() => {
  //       const updatedCards = getValues("cards");
  //       calculateCosts(updatedCards);
  //     }, 0);
  //   }
  // };
  // const handleRemoveCard = (index) => {
  //   const currentCards = getValues("cards");
  //   if (cardFields.length > 1) {
  //     removeCard(index);
  //     setTimeout(() => {
  //       const updatedCards = getValues("cards");
  //       calculateCosts(updatedCards);
  //     }, 0);
  //   }
  // };

  const handleRemoveOthercost = (index) => {
    const currentOthercost = getValues("otherCost");
    if (otherCostFields.length > 0) {
      removeOtherCost(index);
      setTimeout(() => {
        const updatedOthercost = getValues("otherCost");
        calculateCosts(updatedOthercost);
      }, 0);
    }
  };

  const handleDragEnd = (result) => {
    const { destination, source } = result;
    if (!destination || destination.index === source.index) return;
    const currentValues = getValues("cards");
    const reorderedCards = [...currentValues];
    const [removed] = reorderedCards.splice(source.index, 1);
    reorderedCards.splice(destination.index, 0, removed);
    setValue("cards", reorderedCards);

    // Reorder originalVendors to match the new card order
    const currentOriginalVendors = getValues("originalVendors") || {};
    const reorderedOriginalVendors = {};
    Object.keys(currentOriginalVendors).forEach((key) => {
      const oldIndex = parseInt(key);
      let newIndex = oldIndex;
      if (oldIndex === source.index) {
        newIndex = destination.index;
      } else if (
        oldIndex >= Math.min(source.index, destination.index) &&
        oldIndex <= Math.max(source.index, destination.index)
      ) {
        newIndex = oldIndex > source.index ? oldIndex - 1 : oldIndex + 1;
      }
      reorderedOriginalVendors[newIndex] = currentOriginalVendors[oldIndex];
    });
    setValue("originalVendors", reorderedOriginalVendors);

    // Reorder marginWarnings
    const reorderedMarginWarnings = {};
    Object.keys(marginWarnings).forEach((key) => {
      const oldIndex = parseInt(key);
      let newIndex = oldIndex;
      if (oldIndex === source.index) {
        newIndex = destination.index;
      } else if (
        oldIndex >= Math.min(source.index, destination.index) &&
        oldIndex <= Math.max(source.index, destination.index)
      ) {
        newIndex = oldIndex > source.index ? oldIndex - 1 : oldIndex + 1;
      }
      reorderedMarginWarnings[newIndex] = marginWarnings[oldIndex];
    });
    setMarginWarnings(reorderedMarginWarnings);

    // Reorder vendorWarnings
    const reorderedVendorWarnings = {};
    Object.keys(vendorWarnings).forEach((key) => {
      const oldIndex = parseInt(key);
      let newIndex = oldIndex;
      if (oldIndex === source.index) {
        newIndex = destination.index;
      } else if (
        oldIndex >= Math.min(source.index, destination.index) &&
        oldIndex <= Math.max(source.index, destination.index)
      ) {
        newIndex = oldIndex > source.index ? oldIndex - 1 : oldIndex + 1;
      }
      reorderedVendorWarnings[newIndex] = vendorWarnings[oldIndex];
    });
    setVendorWarnings(reorderedVendorWarnings);
  };

  // const handleDragEnd = (result) => {
  //   const { destination, source } = result;
  //   if (!destination || destination.index === source.index) return;
  //   const currentValues = getValues("cards");
  //   const reorderedCards = [...currentValues];
  //   const [removed] = reorderedCards.splice(source.index, 1);
  //   reorderedCards.splice(destination.index, 0, removed);
  //   setValue("cards", reorderedCards);

  //   // Reorder originalVendors to match the new card order
  //   const currentOriginalVendors = getValues("originalVendors") || {};
  //   const reorderedOriginalVendors = {};
  //   Object.keys(currentOriginalVendors).forEach((key, idx) => {
  //     const newIndex =
  //       idx === source.index
  //         ? destination.index
  //         : idx < source.index && idx >= destination.index
  //         ? idx + 1
  //         : idx > source.index && idx <= destination.index
  //         ? idx - 1
  //         : idx;
  //     reorderedOriginalVendors[newIndex] = currentOriginalVendors[key];
  //   });
  //   setValue("originalVendors", reorderedOriginalVendors);
  // };

  // const handleDragEnd = (result) => {
  //   const { destination, source } = result;
  //   if (!destination || destination.index === source.index) return;
  //   const currentValues = getValues("cards");
  //   const reorderedCards = [...currentValues];
  //   const [removed] = reorderedCards.splice(source.index, 1);
  //   reorderedCards.splice(destination.index, 0, removed);
  //   setValue("cards", reorderedCards);
  // };

  const computeCustomerCost = (cost, margin) =>
    parseFloat(margin) === 0 ? 0 : cost / (1 - margin / 100);

  const calculateCosts = (name) => {
    let currentfield = "";
    let currentindex = null;
    if (typeof name === "string") {
      const pathParts = name.match(/cards\[(\d+)\]\.(\w+)$/);
      currentindex = pathParts ? parseInt(pathParts[1]) : null;
      currentfield = pathParts ? pathParts[2] : null;
    }

    console.log("currentindex", currentindex, currentfield);

    let totalBeforeMargin = 0;
    let totalAfterMargin = 0;

    const cards = getValues("cards") || [];
    const otherCost = getValues("otherCost") || [];
    const shippingCost = parseFloat(getValues("shippingCost")) || 0;
    const tax = parseFloat(getValues("tax")) || 0;

    cards?.forEach((card, index) => {
      if (
        currentfield !== "" &&
        currentindex !== null &&
        currentindex !== index
      ) {
        // This card didn't change - just add its totals
        totalBeforeMargin +=
          parseFloat(card.cost || 0) * parseFloat(card.qty || 0);
        totalAfterMargin +=
          parseFloat(card.customerCost || 0) * parseFloat(card.qty || 0);
        return; // Skip recalculation for this card
      }

      if (currentfield != "" && currentindex === index) {
        const customerCostLock = card.customerCostLock;
        const costLock = card.CostLock;
        const marginLock = card.marginLock;
        const qty = parseFloat(card.qty) || 0;
        let cost = parseFloat(card.cost) || 0;
        let margin = parseFloat(card.margin) || 0;
        let customerCost = parseFloat(card.customerCost) || 0;
        let totalSkuCost = 0;
        const lockFields = ["customerCostLock", "CostLock", "marginLock"];

        if (lockFields.includes(currentfield)) {
          return;
        }

        if (
          customerCostLock == false &&
          costLock == false &&
          marginLock == false
        ) {
          if (currentfield == "customerCost") {
            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            if (cost == 0) {
              margin = 0;
              setValue(
                `cards[${cards.indexOf(card)}].cost`,
                roundToMoney(totalSkuCost),
              );
            } else {
              margin = parseFloat(
                ((roundedCustomerCost - cost) / roundedCustomerCost) * 100,
              );
            }

            // ADDED: Store rounded customerCost
            setValue(
              `cards[${cards.indexOf(card)}].margin`,
              roundToMoney(margin, 4),
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          } else {
            console.log("customer calculate");
            // const customerCost = cost / (1 - margin / 100);
            const customerCost = computeCustomerCost(cost, margin);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].customerCost`,
              roundedCustomerCost,
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          }
        } else if (customerCostLock === true) {
          if (currentfield == "cost") {
            margin = parseFloat(((customerCost - cost) / customerCost) * 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].margin`,
              roundToMoney(margin, 4),
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          } else if (currentfield == "margin") {
            const costCust = customerCost * (1 - margin / 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].cost`,
              roundToMoney(costCust),
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          } else {
            // const customerCost = cost / (1 - margin / 100);
            const customerCost = computeCustomerCost(cost, margin);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(`cards[${cards.indexOf(card)}].cost`, roundToMoney(cost));
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          }
        } else if (marginLock == true) {
          if (currentfield == "cost") {
            // const customerCost = cost / (1 - margin / 100);
            const customerCost = computeCustomerCost(cost, margin);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].customerCost`,
              roundedCustomerCost,
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          } else if (currentfield == "customerCost") {
            const costCust = customerCost * (1 - margin / 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].cost`,
              roundToMoney(costCust),
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          } else {
            // const customerCost = cost / (1 - margin / 100);
            const customerCost = computeCustomerCost(cost, margin);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(`cards[${cards.indexOf(card)}].cost`, roundToMoney(cost));
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          }
        } else if (costLock == true) {
          if (currentfield == "margin") {
            // const customerCost = cost / (1 - margin / 100);
            const customerCost = computeCustomerCost(cost, margin);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].customerCost`,
              roundedCustomerCost,
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          } else {
            margin = parseFloat(((customerCost - cost) / customerCost) * 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].margin`,
              roundToMoney(margin, 4),
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          }
        }

        // FIXED: Use rounded values for accumulation
        totalBeforeMargin += roundToMoney(cost * qty);
        totalAfterMargin += roundToMoney(totalSkuCost);
      } else {
        totalBeforeMargin += parseFloat(card.cost * card.qty);
        totalAfterMargin += parseFloat(card.customerCost * card.qty);
      }
    });

    // Calculate costs for each other cost
    otherCost?.forEach((costItem) => {
      const amount = parseFloat(costItem.Amount) || 0;
      if (amount > 0) {
        totalBeforeMargin += parseFloat(amount);
        totalAfterMargin += parseFloat(amount);
      }
    });

    if (shippingCost > 0) {
      totalBeforeMargin += parseFloat(shippingCost);
      totalAfterMargin += parseFloat(shippingCost);
    }

    // Add tax if enabled
    if (tax > 0) {
      totalBeforeMargin += parseFloat(tax);
      totalAfterMargin += parseFloat(tax);
    }

    // Set the final values - FIXED
    setTotalCostBeforeMargin(roundToMoney(totalBeforeMargin));
    setTotalCostAfterMargin(roundToMoney(totalAfterMargin));

    // Update form state - FIXED
    setValue("totalCostBeforeMargin", roundToMoney(totalBeforeMargin));
    setValue("totalCostAfterMargin", roundToMoney(totalAfterMargin));
  };

  // const calculateCosts = (name) => {
  //   let currentfield = "";
  //   let currentindex = null;
  //   if (typeof name === "string") {
  //     const pathParts = name.match(/cards\[(\d+)\]\.(\w+)/);
  //     currentindex = pathParts ? parseInt(pathParts[1]) : null;
  //     currentfield = pathParts ? pathParts[2] : null;
  //   }

  //   let totalBeforeMargin = 0;
  //   let totalAfterMargin = 0;

  //   const cards = getValues("cards") || [];
  //   const otherCost = getValues("otherCost") || [];
  //   const shippingCost = parseFloat(getValues("shippingCost")) || 0;
  //   const tax = parseFloat(getValues("tax")) || 0;

  //   cards?.forEach((card, index) => {

  //     if (currentfield !== "" && currentindex !== null && currentindex !== index) {
  //       // This card didn't change - just add its totals
  //       totalBeforeMargin += parseFloat(card.cost || 0) * parseFloat(card.qty || 0);
  //       totalAfterMargin += parseFloat(card.customerCost || 0) * parseFloat(card.qty || 0);
  //       return; // Skip recalculation for this card
  //     }

  //     if (currentfield != "" && currentindex === index) {
  //       const customerCostLock = card.customerCostLock;
  //       const costLock = card.CostLock;
  //       const marginLock = card.marginLock;
  //       const qty = parseFloat(card.qty) || 0;
  //       let cost = parseFloat(card.cost) || 0;
  //       let margin = parseFloat(card.margin) || 0;
  //       let customerCost = parseFloat(card.customerCost) || 0;
  //       let totalSkuCost = 0;
  //       const lockFields = ["customerCostLock", "CostLock", "marginLock"];

  //       if (lockFields.includes(currentfield)) {
  //         return;
  //       }

  //       if (
  //         customerCostLock == false &&
  //         costLock == false &&
  //         marginLock == false
  //       ) {
  //         if (currentfield == "customerCost") {
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           // margin = parseFloat((customerCost / cost - 1) * 100);
  //           if (cost == 0) {
  //             margin = 0;
  //             setValue(
  //               `cards[${cards.indexOf(card)}].cost`,
  //               truncateFormat(totalSkuCost, 2)
  //             );
  //           } else {
  //             margin = parseFloat(((customerCost - cost) / customerCost) * 100);
  //           }
  //           setValue(
  //             `cards[${cards.indexOf(card)}].margin`,
  //             truncateFormat(margin, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         } else {
  //           // const customerCost = cost * (1 + margin / 100);
  //           const customerCost = cost / (1 - margin / 100);
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].customerCost`,
  //             truncateFormat(customerCost, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         }
  //       } else if (customerCostLock === true) {
  //         if (currentfield == "cost") {
  //           // margin = parseFloat((customerCost / cost - 1) * 100);
  //           margin = parseFloat(((customerCost - cost) / customerCost) * 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].margin`,
  //             truncateFormat(margin, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         } else if (currentfield == "margin") {
  //           // margin = parseFloat((customerCost / cost - 1) * 100);
  //           const costCust = customerCost * (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].cost`,
  //             truncateFormat(costCust, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         } else {
  //           // margin
  //           // cost = customerCost / (1 + margin / 100);
  //           const customerCost = cost / (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].cost`,
  //             truncateFormat(cost, 2)
  //           );
  //           // setValue(
  //           //   `cards[${cards.indexOf(card)}].cost`,
  //           //   truncateFormat(cost, 2)
  //           // );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         }
  //       } else if (marginLock == true) {
  //         if (currentfield == "cost") {
  //           // const customerCost = cost * (1 + margin / 100);
  //           const customerCost = cost / (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].customerCost`,
  //             truncateFormat(customerCost, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         } else if (currentfield == "customerCost") {
  //           const costCust = customerCost * (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].cost`,
  //             truncateFormat(costCust, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         } else {
  //           // customer cost
  //           // cost = customerCost / (1 + margin / 100);
  //           const customerCost = cost / (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].cost`,
  //             truncateFormat(cost, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         }
  //       } else if (costLock == true) {
  //         if (currentfield == "margin") {
  //           // const customerCost = cost * (1 + margin / 100);
  //           const customerCost = cost / (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].customerCost`,
  //             truncateFormat(customerCost, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         } else {
  //           // customer cost change , need to calculate margin
  //           // margin = parseFloat((customerCost / cost - 1) * 100);
  //           margin = parseFloat(((customerCost - cost) / customerCost) * 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].margin`,
  //             truncateFormat(margin, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         }
  //       }
  //       totalBeforeMargin += cost * qty;
  //       totalAfterMargin += parseFloat(totalSkuCost);
  //     } else {
  //       totalBeforeMargin += parseFloat(card.cost * card.qty);
  //       totalAfterMargin += parseFloat(card.customerCost * card.qty);
  //     }
  //   });
  //   // Calculate costs for each other cost
  //   otherCost?.forEach((costItem) => {
  //     const amount = parseFloat(costItem.Amount) || 0;
  //     if (amount > 0) {
  //       totalBeforeMargin += parseFloat(amount);
  //       totalAfterMargin += parseFloat(amount);
  //     }
  //   });
  //   if (shippingCost > 0) {
  //     totalBeforeMargin += parseFloat(shippingCost);
  //     totalAfterMargin += parseFloat(shippingCost);
  //   }
  //   // Add tax if enabled
  //   if (tax > 0) {
  //     // console.log('tax', tax);
  //     totalBeforeMargin += parseFloat(tax);
  //     totalAfterMargin += parseFloat(tax);
  //   }
  //   // Set the final values
  //   setTotalCostBeforeMargin(truncateFormat(totalBeforeMargin, 2));
  //   setTotalCostAfterMargin(truncateFormat(totalAfterMargin, 2));
  //   // Update form state
  //   setValue("totalCostBeforeMargin", truncateFormat(totalBeforeMargin, 2));
  //   setValue("totalCostAfterMargin", truncateFormat(totalAfterMargin, 2));
  // };

  const isCalculating = useRef(false);
  const shipping_terms = watch("shipping_terms");

  useEffect(() => {
    if (shipping_terms === "FOB Destination") {
      setShippingHide(true);
    }
  }, [watch("shipping_terms")]);

  useEffect(() => {
    const subscription = watch((value, { name }) => {
      //console.log('set name',name);
      const match = name?.match(
        /cards\[(\d+)\]\.(qty|cost|margin|customerCost)$/,
      );
      const otherCostMatch = name?.match(/otherCost\[(\d+)\]\.Amount/);
      if (match || otherCostMatch) {
        if (!isCalculating.current) {
          isCalculating.current = true;
          calculateCosts(name);
          isCalculating.current = false;
        }
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    if (!isCalculating.current) {
      isCalculating.current = true;
      calculateCosts();
      isCalculating.current = false;
    }
  }, [watch("shippingCost"), watch("tax"), watch("cards"), watch("otherCost")]);

  const [activeCardIndex, setActiveCardIndex] = useState(null);
  const [cardSearch, setCardSearch] = useState(
    cardFields.map(() => ({
      vendor: "",
      description: "",
      sku: "",
      showSuggestions: true,
    })),
  );

  const handleInputFocus = (index) => {
    setActiveCardIndex(index);
    const updatedCardSearch = cardSearch.map((card, idx) => {
      if (idx !== index) {
        return { ...card, showSuggestions: false };
      }
      return card;
    });
    setCardSearch(updatedCardSearch);
  };

  const handleSearchChange = (index, field, value) => {
    setValue(`cards[${index}].skuIdUnique`, value);
    const vendorPartner = watch(`cards[${index}].vendorPartner`) || "";
    const updatedCardSearch = [...cardSearch];
    if (field === "sku") {
      updatedCardSearch[index] = {
        ...updatedCardSearch[index],
        sku: value,
        vendor: vendorPartner,
        description: "",
        showSuggestions: true,
      };
    } else if (field === "vendor") {
      updatedCardSearch[index] = {
        ...updatedCardSearch[index],
        vendor: value,
        sku: "",
        description: "",
        showSuggestions: true,
      };
    } else if (field === "description") {
      updatedCardSearch[index] = {
        ...updatedCardSearch[index],
        description: value,
        sku: "",
        vendor: "",
        showSuggestions: true,
      };
    }
    setCardSearch(updatedCardSearch);
  };

  const handleSearchChangeDescription = (index, field, value) => {
    const vendorPartner = watch(`cards[${index}].vendorPartner`) || "";
    const updatedCardSearch = [...cardSearch];
    if (field === "sku") {
      updatedCardSearch[index] = {
        ...updatedCardSearch[index],
        sku: value,
        vendor: vendorPartner,
        description: "",
        showSuggestions: true,
      };
    } else if (field === "vendor") {
      updatedCardSearch[index] = {
        ...updatedCardSearch[index],
        vendor: value,
        sku: "",
        description: "",
        showSuggestions: true,
      };
    } else if (field === "description") {
      updatedCardSearch[index] = {
        ...updatedCardSearch[index],
        description: value,
        sku: "",
        vendor: "",
        showSuggestions: true,
      };
    }
    setCardSearch(updatedCardSearch);
  };

  const { postData: fetchProductSearch, data } = usePostRequest(
    API_ENDPOINTS.PRODUCT_SUGGETION,
  );

  const onSuccessData = (data) => {
    setDataSuggetion(data);
  };

  useEffect(() => {
    const vendorPartner =
      watch(`cards[${activeCardIndex}].vendorPartner`) || "";
    // console.log("vendorPartner", vendorPartner);
    if (
      activeCardIndex === null ||
      !cardSearch[activeCardIndex]?.showSuggestions
    ) {
      return;
    }

    const { vendor, sku, description } = cardSearch[activeCardIndex];

    if (!vendor && !sku && !description) {
      return;
    }

    const vehicleId = watch("vehicleId");
    const requestPayload = {
      page,
      limit,
      module_type: "RFQ",
      vendor: vendorPartner?.length > 0 ? vendorPartner : undefined,
      is_variant: true,
      sku: sku?.length > 0 ? sku : undefined,
      description: description?.length > 0 ? description : undefined,
    };
    if (contractVehicletype?.split(",").includes("product-bound")) {
      requestPayload.contract_type_id = vehicleId;
    }
    const debounceTimer = setTimeout(() => {
      fetchProductSearch(requestPayload, onSuccessData);
    }, 500);
    return () => clearTimeout(debounceTimer);
    // const debounceTimer = setTimeout(() => {
    //   fetchProductSearch(
    //     {
    //       page,
    //       limit,
    //       module_type: "RFQ",
    //       vendor: vendorPartner?.length > 0 ? vendorPartner : undefined,
    //       sku: sku?.length > 0 ? sku : undefined,
    //       description: description?.length > 0 ? description : undefined,
    //     },
    //     onSuccessData
    //   );
    // }, 500);
    // return () => clearTimeout(debounceTimer);
  }, [cardSearch, page, limit, activeCardIndex]);

  const textAreaRefs = useRef([]);

  const adjustTextAreaHeight = (index) => {
    const textArea = textAreaRefs.current[index];
    if (textArea) {
      textArea.style.height = "auto";
      textArea.style.height = `${textArea.scrollHeight}px`;
    }
  };

  const handleProductSelect = (product, index) => {
    // if(product?.Vendor?.display_name === ''){
    //   setShowModal2(true);
    // }
    const currentValues = getValues("cards") || [];
    if (contractVehicletype?.split(",").includes("product-bound")) {
      const isDuplicate = currentValues.some(
        (item, idx) => item?.rowId === product?.raw_sku_id && idx !== index,
      );

      if (isDuplicate) {
        toast.error(
          `Product with SKU ${product.sku_display_name} already exists.`,
        );
        return;
      }
    }

    setVendorWarnings((prev) => {
      const updated = { ...prev };
      delete updated[index];
      return updated;
    });

    const currentOriginalVendors = getValues("originalVendors") || {};
    setValue("originalVendors", {
      ...currentOriginalVendors,
      [index]: product?.Vendor?.display_name,
    });

    setValue(`cards[${index}].vendorPartner`, product?.Vendor?.display_name, {
      shouldValidate: true,
    });
    setValue(`cards[${index}].productName`, product?.name, {
      shouldValidate: true,
    });
    setValue(`cards[${index}].skuIdUnique`, product?.sku_id, {
      shouldValidate: true,
    });
    if (contractVehicletype?.split(",").includes("product-bound")) {
      setValue(`cards[${index}].rowId`, product?.raw_sku_id, {
        shouldValidate: true,
      });
    }
    setValue(`cards[${index}].skuId`, product?.sku_display_name, {
      shouldValidate: true,
    });
    setValue(`cards[${index}].skuDescription`, product?.description_sales, {
      shouldValidate: true,
    }); // Description update
    setValue(`cards[${index}].purchase_description`, product?.description, {
      shouldValidate: true,
    }); // Description update
    setValue(
      `cards[${index}].internalSku`,
      product?.internal_id || product?.vendor_sku || "",
      {
        shouldValidate: true,
      },
    );
    setValue(`cards[${index}].variantId`, product?.variant_id || "", {
      shouldValidate: true,
    });
    setValue(`cards[${index}].um`, product?.uoi, { shouldValidate: true });
    setValue(`cards[${index}].cost`, product?.aspetto_price, {
      shouldValidate: true,
    });
    setValue(`cards[${index}].customerCost`, product?.customer_price, {
      shouldValidate: true,
    });
    if (product?.customer_price === "0.00") {
      setValue(`cards[${index}].margin`, "8", {
        shouldValidate: true,
      });
    }
    // setValue(`cards[${index}].margin`, product?.margin_percent, {
    //   shouldValidate: true,
    // });

    const textArea = textAreaRefs.current[index];
    if (textArea) {
      textArea.value = product?.description_sales; //description
      adjustTextAreaHeight(index);
    }

    const updatedCardSearch = [...cardSearch];
    updatedCardSearch[index] = {
      ...updatedCardSearch[index],
      showSuggestions: false,
    };
    setCardSearch(updatedCardSearch);
  };

  useEffect(() => {
    cardFields.forEach((_, index) => {
      adjustTextAreaHeight(index);
    });
  }, [cardFields]);

  const cards = watch("cards");

  const handleLockChange = (field, index) => {
    const currentState = watch(`cards[${index}]`);
    if (currentState[field]) {
      setValue(`cards[${index}].${field}`, false);
    } else {
      // Otherwise, lock it and unlock all others
      setValue(`cards[${index}].CostLock`, field === "CostLock");
      setValue(`cards[${index}].marginLock`, field === "marginLock");
      setValue(
        `cards[${index}].customerCostLock`,
        field === "customerCostLock",
      );
    }
  };

  const updateTextAreaWithDescription = (index, description) => {
    const textArea = textAreaRefs.current[index];
    if (textArea) {
      textArea.value = description;
      adjustTextAreaHeight(index);
    }
  };

  const suggestionBoxRefs = useRef([]);
  const vendorSuggestionRefs = useRef([]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the click is outside all suggestion boxes for products
      const isProductOutside = cardSearch.every((_, index) => {
        const suggestionBox = suggestionBoxRefs.current[index];
        return suggestionBox ? !suggestionBox.contains(event.target) : true;
      });

      if (isProductOutside) {
        // Close all product suggestion boxes and clear suggestions
        setDataSuggetion(null);
        setCardSearch((prev) =>
          prev.map((card) => ({
            ...card,
            showSuggestions: false,
          })),
        );
      }

      // Check if the click is outside all vendor suggestion boxes
      const isVendorOutside = vendorSuggestionRefs.current.every((box) =>
        box ? !box.contains(event.target) : true,
      );

      if (isVendorOutside) {
        setSuggestionData([]);
        setSearchDebounces({ searchName: "" });
      }
    };

    // Add event listener for mousedown
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [cardSearch]);

  const handleProductsClick = (autoId) => {
    console.log("this is triggered");
    setShowFbopPopup(false);
    setSelectedAutoId(autoId);
    setShowPdfProductsPopup(true);
  };

  return (
    <>
      <FbopPdfPopup
        show={showFbopPopup}
        onClose={() => setShowFbopPopup(false)}
        onProductsClick={handleProductsClick}
      />
      <PdfProductsPopup
        show={showPdfProductsPopup}
        onClose={() => setShowPdfProductsPopup(false)}
        autoId={selectedAutoId}
        onSubmitSuccess={handleAddSkuBulk}
      />
      <SkuSearchPopUp
        calculateCosts={calculateCosts}
        show={showModal}
        searchProps={searchProps}
        updateTextArea={updateTextAreaWithDescription}
        setSearchProps={setSearchProps}
        setShow={setShowModal}
        onAddSku={handleAddSku}
        setCardSearch={setCardSearch}
        cardSearch={cardSearch}
        searchType={searchType}
        // setOriginalVendors={setOriginalVendors} // Add this prop
        // setVendorWarnings={setVendorWarnings}
      />
      <div className="drag_section">
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="droppable-cards">
            {(provided) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                {cardFields.map((card, index) => (
                  <Draggable
                    key={card.id}
                    draggableId={`card-${index}`}
                    index={index}
                  >
                    {(provided) => (
                      <Card
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className="mb-3"
                      >
                        <Card.Body>
                          <div className="grag_flex_row">
                            <div className="drag_icon_set">
                              <div
                                className="drag_icon_group trash_icon"
                                {...provided.dragHandleProps}
                              >
                                {cardFields.length > 1 && (
                                  <IconTrash
                                    onClick={() => handleRemoveCard(index)}
                                  />
                                )}
                                <IconArrowsUpDown size={21} style={{ cursor: "move" }} />
                              </div>
                            </div>

                            <input
                              type="hidden"
                              {...register(`cards[${index}].variantId`)}
                            />

                            <div className="drag_fields_grid">
                              {/* ===== LEFT: 3 cols ===== */}
                              <div className="drag_fields_left">
                                {/* Row 1 Left */}
                                <div>
                                  <Form.Group>
                                    <Form.Label className="">
                                      VENDOR NAME
                                    </Form.Label>
                                    <InputGroup>
                                      <Form.Control
                                        {...register(
                                          `cards[${index}].vendorPartner`,
                                        )}
                                        defaultValue={card.vendorPartner}
                                        placeholder="Enter Name"
                                        // value={cardSearch[activeCardIndex]?.vendor || ""}
                                        onChange={handleSearchByName}
                                        // onChange={(e) =>
                                        //   handleSearchChange(
                                        //     activeCardIndex,
                                        //     "vendor",
                                        //     e.target.value
                                        //   )
                                        // }
                                        onFocus={() => handleInputFocus(index)}
                                      />
                                    </InputGroup>
                                    <div>
                                      {index === activeCardIndex &&
                                        suggestionData?.data?.length > 0 &&
                                        searchDebounces?.searchName?.length >
                                          0 && (
                                          <div
                                            className="suggestions_box"
                                            ref={(el) =>
                                              (vendorSuggestionRefs.current[
                                                index
                                              ] = el)
                                            }
                                          >
                                            <div className="table-responsive">
                                              <Table>
                                                <tbody>
                                                  {suggestionData?.data?.map(
                                                    (item, idx) => (
                                                      <tr
                                                        key={idx}
                                                        onClick={() =>
                                                          handleSelectVendor(
                                                            item,
                                                            index,
                                                          )
                                                        }
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                      >
                                                        <td>
                                                          {item?.display_name}
                                                        </td>
                                                      </tr>
                                                    ),
                                                  )}
                                                </tbody>
                                              </Table>
                                            </div>
                                          </div>
                                        )}
                                    </div>
                                    {errors?.cards?.[index]?.vendorPartner && (
                                      <span className="text-danger">
                                        {/* {errors.cards[index].vendorPartner.message} */}
                                      </span>
                                    )}
                                  </Form.Group>
                                </div>

                                <div>
                                  <Form.Group>
                                    <Form.Label className="">
                                      PRODUCT NAME
                                    </Form.Label>
                                    <InputGroup>
                                      <Form.Control
                                        {...register(
                                          `cards[${index}].productName`,
                                        )}
                                        // value={watch(`cards[${index}].skuId`)}
                                        placeholder="Product Name"
                                        // defaultValue={card.skuId}
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </div>

                                {/* Row 2 Left */}
                                <div>
                                  <Form.Group>
                                    <Form.Label>INTERNAL SKU</Form.Label>
                                    <InputGroup>
                                      <Form.Control
                                        {...register(
                                          `cards[${index}].internalSku`,
                                        )}
                                        placeholder="Internal SKU"
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </div>

                                <div>
                                  <Form.Group>
                                    <Form.Label className="required">
                                      VENDOR SKU
                                    </Form.Label>
                                    <InputGroup>
                                      <Form.Control
                                        {...register(`cards[${index}].skuId`)}
                                        // value={watch(`cards[${index}].skuId`)}
                                        placeholder="Vendor SKU"
                                        defaultValue={card.skuId}
                                        onChange={(e) =>
                                          handleSearchChange(
                                            activeCardIndex,
                                            "sku",
                                            e.target.value,
                                          )
                                        }
                                        onFocus={() => handleInputFocus(index)}
                                      />
                                    </InputGroup>
                                    {errors?.cards?.[index]?.skuId && (
                                      <span className="text-danger">
                                        {/* {errors.cards[index].skuId.message} */}
                                      </span>
                                    )}
                                  </Form.Group>
                                </div>
                              </div>

                              {/* ===== CENTER: 6 cols — Sales Description full height ===== */}
                              <div className="drag_fields_center">
                                <Form.Group
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    flex: 1,
                                  }}
                                >
                                  <Form.Label className="">
                                    SALES DESCRIPTION
                                  </Form.Label>

                                  <InputGroup style={{ flex: 1 }}>
                                    <Form.Control
                                      as="textarea"
                                      rows={1}
                                      {...(() => {
                                        const { ref, onChange, ...rest } =
                                          register(
                                            `cards[${index}].skuDescription`,
                                          );
                                        return {
                                          ...rest,
                                          ref: (el) => {
                                            ref(el);
                                            textAreaRefs.current[index] = el;
                                          },
                                          onChange: (e) => {
                                            onChange(e);
                                            handleSearchChangeDescription(
                                              index,
                                              "description",
                                              e.target.value,
                                              setValue(
                                                `cards[${index}].skuDescription`,
                                                e.target.value,
                                              ),
                                            );
                                            adjustTextAreaHeight(index); // Resize on input change
                                          },
                                        };
                                      })()}
                                      defaultValue={card.skuDescription}
                                      placeholder="Sales Description"
                                      style={{
                                        resize: "none",
                                        overflow: "hidden",
                                        height: "100%",
                                      }}
                                      onFocus={() => handleInputFocus(index)}
                                    />
                                  </InputGroup>
                                  {errors?.cards?.[index]?.skuDescription && (
                                    <span className="text-danger">
                                      {/* {errors.cards[index].skuDescription.message} */}
                                    </span>
                                  )}
                                </Form.Group>
                              </div>

                              {/* ===== RIGHT: 3 cols ===== */}
                              <div className="drag_fields_right">
                                {/* Row 1 Right: QTY, Cost, Margin, Price */}
                                <div>
                                  <Form.Group>
                                    <Form.Label className="">QTY</Form.Label>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        step="any"
                                        onKeyDown={handleKeyDown}
                                        {...register(`cards[${index}].qty`, {
                                          required: "Quantity is required",
                                          pattern: {
                                            value: /^[0-9]+$/,
                                            message:
                                              "Quantity must be a number",
                                          },
                                        })}
                                        defaultValue={card.qty}
                                        placeholder="0"
                                      />
                                    </InputGroup>
                                    {errors?.cards?.[index]?.qty && (
                                      <span className="text-danger">
                                        {/* {errors.cards[index].qty.message} */}
                                      </span>
                                    )}
                                  </Form.Group>
                                </div>

                                <div>
                                  <Form.Group className="lock_group">
                                    <Form.Label className="">Cost</Form.Label>
                                    <InputGroup>
                                      <InputGroup.Text>
                                        <IconCurrencyDollar stroke={2} />
                                      </InputGroup.Text>
                                      <Form.Control
                                        type="text"
                                        step="any"
                                        onKeyDown={handleKeyDown}
                                        {...register(`cards[${index}].cost`, {
                                          required: "Aspetto Cost is required",
                                          pattern: {
                                            value: /^[0-9]+(\.[0-9]{1,2})?$/,
                                            message: "Enter a valid cost",
                                          },
                                        })}
                                        defaultValue={card.cost}
                                        placeholder="Enter Cost"
                                        disabled={watch(
                                          `cards[${index}].CostLock`,
                                        )}
                                      />
                                    </InputGroup>
                                    {errors?.cards?.[index]?.cost && (
                                      <span className="text-danger">
                                        {/* {errors.cards[index].cost.message} */}
                                      </span>
                                    )}
                                    <span className="lock_unlock">
                                      <Form.Check
                                        type="switch" // Using 'switch' for better visual feedback, but you can keep 'checkbox' if preferred
                                        id={`lock-toggle-${index}`}
                                        label={
                                          <>
                                            {watch(
                                              `cards[${index}].CostLock`,
                                            ) ? (
                                              <IconLock stroke={1} />
                                            ) : (
                                              <IconLockOpen2 stroke={1} />
                                            )}
                                          </>
                                        }
                                        {...register(
                                          `cards[${index}].CostLock`,
                                        )}
                                        checked={watch(
                                          `cards[${index}].CostLock`,
                                        )}
                                        onChange={() =>
                                          handleLockChange("CostLock", index)
                                        }
                                      />
                                    </span>
                                  </Form.Group>
                                </div>

                                <div>
                                  <Form.Group className="lock_group">
                                    <Form.Label className="">Margin</Form.Label>
                                    <InputGroup>
                                      <InputGroup.Text>
                                        <IconPercentage stroke={2} />
                                      </InputGroup.Text>
                                      <Form.Control
                                        onKeyDown={handleKeyDown}
                                        type="text"
                                        step="any"
                                        {...register(`cards[${index}].margin`, {
                                          required: "Margin is required",
                                        })}
                                        onChange={(e) =>
                                          handleMarginChange(
                                            index,
                                            e.target.value,
                                          )
                                        }
                                        defaultValue={card.margin}
                                        placeholder="0.00"
                                        disabled={watch(
                                          `cards[${index}].marginLock`,
                                        )}
                                      />
                                    </InputGroup>
                                    {errors?.cards?.[index]?.margin && (
                                      <span className="text-danger">
                                        {errors.cards[index].margin.message}
                                      </span>
                                    )}
                                    <span className="lock_unlock">
                                      <Form.Check
                                        type="switch" // Using 'switch' for better visual feedback, but you can keep 'checkbox' if preferred
                                        id={`margin-lock-toggle-${index}`}
                                        label={
                                          <>
                                            {watch(
                                              `cards[${index}].marginLock`,
                                            ) ? (
                                              <IconLock stroke={1} />
                                            ) : (
                                              <IconLockOpen2 stroke={1} />
                                            )}
                                          </>
                                        }
                                        {...register(
                                          `cards[${index}].marginLock`,
                                        )}
                                        checked={watch(
                                          `cards[${index}].marginLock`,
                                        )}
                                        onChange={() =>
                                          handleLockChange("marginLock", index)
                                        }
                                      />
                                    </span>
                                  </Form.Group>
                                </div>

                                <div>
                                  <Form.Group className="lock_group">
                                    <Form.Label>Price</Form.Label>
                                    <InputGroup>
                                      <InputGroup.Text>
                                        <IconCurrencyDollar stroke={2} />
                                      </InputGroup.Text>
                                      <Form.Control
                                        type="text"
                                        step="any"
                                        onKeyDown={handleKeyDown}
                                        {...register(
                                          `cards[${index}].customerCost`,
                                          {
                                            required:
                                              "Customer's cost is required",
                                            pattern: {
                                              value: /^[0-9]+(\.[0-9]{1,2})?$/,
                                              message:
                                                "Enter a valid customer cost",
                                            },
                                          },
                                        )}
                                        defaultValue={card.customerCost}
                                        placeholder="Enter Price"
                                        disabled={watch(
                                          `cards[${index}].customerCostLock`,
                                        )}
                                        checked={watch(
                                          `cards[${index}].customerCostLock`,
                                        )}
                                      />
                                    </InputGroup>
                                    {errors?.cards?.[index]?.customerCost && (
                                      <span className="text-danger">
                                        {/* {errors.cards[index].customerCost.message} */}
                                      </span>
                                    )}
                                    <span className="lock_unlock">
                                      <Form.Check
                                        type="switch"
                                        id={`customer-cost-lock-toggle-${index}`}
                                        label={
                                          <>
                                            {watch(
                                              `cards[${index}].customerCostLock`,
                                            ) ? (
                                              <IconLock stroke={1} />
                                            ) : (
                                              <IconLockOpen2 stroke={1} />
                                            )}
                                          </>
                                        }
                                        {...register(
                                          `cards[${index}].customerCostLock`,
                                        )}
                                        checked={watch(
                                          `cards[${index}].customerCostLock`,
                                        )}
                                        onChange={() =>
                                          handleLockChange(
                                            "customerCostLock",
                                            index,
                                          )
                                        }
                                      />
                                    </span>
                                  </Form.Group>
                                </div>

                                {/* Row 2 Right: CLIN, UM, Total Price (span last 3 of 4 cols) */}
                                <div className="drag_fields_right_row2">
                                  <div>
                                    <Form.Group>
                                      <Form.Label className="">CLIN</Form.Label>
                                      <InputGroup>
                                        <Form.Control
                                          // onKeyDown={handleKeyDown}
                                          step="any"
                                          {...register(`cards[${index}].clin`)}
                                          placeholder="CLIN"
                                        />
                                      </InputGroup>
                                      {errors?.cards?.[index]?.clin && (
                                        <span className="text-danger">
                                          {/* {errors.cards[index].clin.message} */}
                                        </span>
                                      )}
                                    </Form.Group>
                                  </div>

                                  <div>
                                    <Form.Group>
                                      <Form.Label>UM</Form.Label>
                                      <InputGroup>
                                        <Form.Control
                                          {...register(`cards[${index}].um`)}
                                          defaultValue={card.um}
                                          placeholder="EA"
                                        />
                                      </InputGroup>
                                      {errors?.cards?.[index]?.um && (
                                        <span className="text-danger">
                                          {/* {errors.cards[index].qty.message} */}
                                        </span>
                                      )}
                                    </Form.Group>
                                  </div>

                                  <div>
                                    <Form.Group>
                                      <Form.Label>TOTAL PRICE</Form.Label>
                                      <InputGroup>
                                        <InputGroup.Text>
                                          <IconCurrencyDollar stroke={2} />
                                        </InputGroup.Text>
                                        <Form.Control
                                          readOnly
                                          type="text"
                                          step="any"
                                          onKeyDown={handleKeyDown}
                                          {...register(
                                            `cards[${index}].totalSkuCost`,
                                            {
                                              required:
                                                "Total SKU cost is required",
                                              pattern: {
                                                value:
                                                  /^[0-9]+(\.[0-9]{1,2})?$/,
                                                message:
                                                  "Enter a valid total SKU cost",
                                              },
                                            },
                                          )}
                                          defaultValue={card.totalSkuCost}
                                          placeholder="Total Price"
                                        />
                                      </InputGroup>
                                      {errors?.cards?.[index]?.totalSkuCost && (
                                        <span className="text-danger">
                                          {
                                            errors.cards[index].totalSkuCost
                                              .message
                                          }
                                        </span>
                                      )}
                                    </Form.Group>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* ===== Conditional: Unique SKU ID, ROW ID ===== */}
                            {showSkuId && (
                              <>
                                <div className="mid_drag_column mob_50">
                                  <Form.Group>
                                    <Form.Label className="">
                                      UNIQUE SKU ID
                                    </Form.Label>
                                    <InputGroup>
                                      <Form.Control
                                        {...register(
                                          `cards[${index}].skuIdUnique`,
                                        )}
                                        // value={watch(`cards[${index}].skuId`)}
                                        placeholder="SKU ID"
                                        // defaultValue={card.skuId}
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </div>
                                <div className="mid_drag_column mob_50">
                                  <Form.Group>
                                    <Form.Label className="">ROW ID</Form.Label>
                                    <InputGroup>
                                      <Form.Control
                                        {...register(`cards[${index}].rowId`)}
                                        // value={watch(`cards[${index}].skuId`)}
                                        placeholder="SKU ID"
                                        // defaultValue={card.skuId}
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </div>
                              </>
                            )}
                          </div>

                          <div className="text-danger text-end mt-2">
                            {marginWarnings[index] && (
                              <div className="mb-1">
                                Margins 12% aren't recommended. Click "Next" to
                                confirm this is intentional.
                              </div>
                            )}
                          </div>
                          <div className="text-danger text-start mt-2">
                            {vendorWarnings[index] && (
                              <div>
                                This name does not match the master vendor. If
                                it’s intentional, hit next to proceed.
                              </div>
                            )}
                          </div>
                          {/* {marginWarnings[index] && (
                            <div className="text-danger text-end">
                              Margins below 12% aren't recommended. Click "Next"
                              to confirm this is intentional.
                            </div>
                          )} */}

                          {cardSearch[index]?.showSuggestions &&
                            (cardSearch[index]?.vendor ||
                              cardSearch[index]?.sku ||
                              cardSearch[index]?.description) &&
                            dataSuggetion?.data?.length > 0 && (
                              <div
                                className="suggestions_box"
                                ref={(el) =>
                                  (suggestionBoxRefs.current[index] = el)
                                }
                              >
                                <div className="table-responsive">
                                  <Table>
                                    <tbody>
                                      {dataSuggetion.data.map(
                                        (product, idx) => (
                                          <tr
                                            key={idx}
                                            onClick={() =>
                                              handleProductSelect(
                                                product,
                                                index,
                                              )
                                            }
                                          >
                                            <td>
                                              {product?.Vendor?.display_name}
                                            </td>
                                            <td>{product?.sku_display_name}</td>
                                            <td>{product?.name}</td>
                                            <td>
                                              {" "}
                                              {trimText(
                                                product?.description_sales,
                                                100,
                                              )}
                                            </td>
                                            <td>{product?.uoi}</td>
                                            <td>${product?.aspetto_price}</td>
                                            <td>{product?.margin_percent}%</td>
                                          </tr>
                                        ),
                                      )}
                                    </tbody>
                                  </Table>
                                </div>
                                <div className="text-center">
                                  <Button
                                    variant="link"
                                    className="see-all-btn"
                                    onClick={() =>
                                      handleOpenModal(index, "sku")
                                    }
                                  >
                                    See All SKUs <IconArrowNarrowRight />
                                  </Button>
                                </div>
                              </div>
                            )}
                        </Card.Body>
                      </Card>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>

          <div className="add_remove_sku mb-0 mb-sm-3">
            <p className="text-center mb-2">Product Items (SKUs)</p>
            <div className="btn_group_sku">
              <Button
                variant=""
                className="add_sku_button"
                onClick={handleAddCard}
              >
                <IconPlus /> BLANK PRODUCT
              </Button>
              <Button
                variant=""
                className="add_sku_button"
                onClick={() => handleOpenModal(null, "skuAll")}
              >
                <IconSearch /> PRODUCTS LIBRARY
              </Button>
              <Button
                variant=""
                className="add_sku_button"
                onClick={() => handleOpenModal(null, "contract")}
              >
                <IconSearch /> CONTRACT VEHICLE LIBRARY
              </Button>
              <Button
                variant=""
                className="add_sku_button"
                onClick={() => setShowFbopPopup(true)}
              >
                <IconSearch /> VALIDATED FORMS
              </Button>
            </div>
          </div>
        </DragDropContext>
      </div>
      <div>
        <Card.Body className="pb-0">
          <Row className={`mb-2 ${shippingHide ? "d-none" : ""}`}>
            <div className="costing_rows p-0">
              <Form.Check
                className="ps-0 pe-2"
                type="switch"
                label="Customer Shipping Charge"
                {...register("shippingCostEnabled")}
                checked={getValues("shippingCostEnabled")}
                onChange={(e) =>
                  setValue("shippingCostEnabled", e.target.checked)
                }
              />
              <div className="costing_input">
                <Form.Group>
                  <InputGroup>
                    <InputGroup.Text>
                      <IconCurrencyDollar stroke={2} />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      step="any"
                      onKeyDown={handleKeyDown}
                      {...register("shippingCost", {
                        required: watch("shippingCostEnabled")
                          ? "Customer Shipping Charge is required"
                          : false,
                        // pattern: {
                        //   value: /^[0-9]+(\.[0-9]{1,2})?$/,
                        //   message: "Enter a valid shipping cost",
                        // },
                      })}
                      disabled={!watch("shippingCostEnabled")}
                    />
                  </InputGroup>
                </Form.Group>
              </div>
            </div>
          </Row>

          <Row className="mb-2">
            <div className="costing_rows p-0">
              <Form.Check
                className="ps-0 pe-2"
                type="switch"
                label="Tax"
                {...register("taxEnabled")}
                checked={getValues("taxEnabled")}
                onChange={(e) => setValue("taxEnabled", e.target.checked)}
              />

              <div className="costing_input">
                <Form.Group>
                  <InputGroup>
                    <InputGroup.Text>
                      <IconCurrencyDollar />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      step="any"
                      // defaultValue={0.00}
                      onKeyDown={handleKeyDown}
                      {...register("tax", {
                        required: watch("taxEnabled")
                          ? "Tax is required"
                          : false,
                        // pattern: {
                        //   value: /^[0-9]+(\.[0-9]{1,2})?$/,
                        //   message: "Enter a valid tax amount",
                        // },
                      })}
                      // placeholder="0.00"
                      disabled={!watch("taxEnabled")}
                    />
                  </InputGroup>
                </Form.Group>
              </div>
            </div>
          </Row>
          <Row className="mb-2 justify-content-end">
            {otherCostFields.map((item, index) => (
              <Row className="mb-2" key={item.id}>
                <div className="costing_rows p-0">
                  <div className="costing_input">
                    <span
                      className="trash_icon"
                      onClick={() => handleRemoveOthercost(index)}
                    >
                      <IconTrash />
                    </span>
                    <Form.Group>
                      <InputGroup className="costing_name">
                        <Form.Control
                          {...register(`otherCost[${index}].Name`)}
                          placeholder="Enter Cost Name"
                        />
                      </InputGroup>
                      {errors?.otherCost?.[index]?.Name && (
                        <span className="text-danger">
                          {/* {errors.cards[index].vendorPartner.message} */}
                        </span>
                      )}
                    </Form.Group>

                    <Form.Group>
                      <InputGroup className="costing_amount">
                        <InputGroup.Text>
                          <IconCurrencyDollar />
                        </InputGroup.Text>
                        <Form.Control
                          type="number"
                          step="any"
                          {...register(`otherCost[${index}].Amount`, {
                            required: "Amount is required",
                            pattern: {
                              value: /^[0-9]+(\.[0-9]{1,2})?$/,
                              message: "Enter a valid amount",
                            },
                          })}
                          placeholder="Amount"
                        />
                      </InputGroup>

                      {errors?.otherCost?.[index]?.Amount && (
                        <span className="text-danger">
                          {/* {errors.cards[index].vendorPartner.message} */}
                        </span>
                      )}
                    </Form.Group>
                  </div>
                </div>
              </Row>
            ))}
            <div className="costing_rows p-0">
              <Button
                variant=""
                className="add_sku_button w-auto"
                onClick={handleAddOtherCost}
              >
                <IconPlus /> OTHER COST
              </Button>
            </div>
          </Row>

          <div className="totle_costing mt-3">
            <h6>
              Total Cost:
              <span>
                <IconCurrencyDollar />
                {totalCostBeforeMargin}
              </span>
            </h6>
            <Form.Control
              {...register("totalCostBeforeMargin")}
              value={totalCostBeforeMargin}
              readOnly
              type="hidden"
              placeholder="Total Cost"
            />
          </div>
          <div className="totle_costing">
            <h6>
              Total Price:
              <span>
                <IconCurrencyDollar />
                {totalCostAfterMargin}
              </span>
            </h6>
            <Form.Control
              {...register("totalCostAfterMargin")}
              value={totalCostAfterMargin}
              readOnly
              type="hidden"
              placeholder="Total Price"
            />
          </div>
        </Card.Body>
      </div>
    </>
  );
}

export default OtherDetailsForm;
